import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { environment } from '@app/environment';

import { ApiConfiguration } from '@app/swagger/api-configuration';

/**
 * Базовый URL для сгенерированных swagger-сервисов: `/api/v<версия>` из
 * `environment.API_VERSION`. Зависит только от leaf-модулей (swagger-клиент и
 * env), не тянет app-слои, поэтому живёт в core рядом с прочими `provideXxx`.
 */
export function provideApiConfiguration(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ApiConfiguration,
      useValue: { rootUrl: `/api/v${environment.API_VERSION}` },
    },
  ]);
}
